import React from 'react';
import personalLoanImage from '../Asserts/personalimag.png'; // Replace with your actual image path
import { Helmet } from 'react-helmet-async';
function Personalloan() {
  const handleApplyNow = () => {
    // Add your logic for the "Apply Now" button
    console.log('Apply Now button clicked');
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4 sm:px-6 lg:px-8">
       <Helmet>
              <title>Kota HOLDINGS</title>
              <meta name="description" content="A Vision of My 30-Year World" />
            </Helmet>
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center gap-8 bg-white p-6 rounded-lg shadow-lg">
        {/* Left Image Section */}
        <div className="w-full md:w-1/2">
          <img
            src={personalLoanImage}
            alt="Personal Loan"
            className="w-full h-auto rounded-lg shadow-md"
          />
        </div>

        {/* Right Text Section */}
        <div className="w-full md:w-1/2 space-y-6 text-center md:text-left">
          <h1 className="text-3xl md:text-4xl font-bold text-[#FF6F00]">
            Get Your Personal Loan Today!
          </h1>
          <p className="text-gray-700 text-base md:text-lg leading-relaxed">
            We offer quick and hassle-free personal loans to meet your financial needs. Whether it's for medical emergencies, education, or any other personal expense, we've got you covered.
          </p>
          <ul className="list-disc list-inside text-gray-700 text-base md:text-lg space-y-2">
            <li>Flexible repayment options</li>
            <li>Competitive interest rates</li>
            <li>Quick approval process</li>
          </ul>
          <button
            onClick={handleApplyNow}
            className="bg-[#FF6F00] text-white px-6 py-3 rounded-lg shadow-md hover:bg-[#E65C00] transition duration-300"
          >
            Apply Now
          </button>
        </div>
      </div>
    </div>
  );
}

export default Personalloan;